import { AssetBackgroundProps, ColorBackgroundProps } from "./types";

export const defaultColorBackgroundConfig: ColorBackgroundProps = {
  hexColor: "black",
};

export const defaultStaticBackgroundConfig: AssetBackgroundProps = {
  asset: { url: "./100_DAVID_CP_BORDER.jpg" },
};

export const defaultBackground360Config: AssetBackgroundProps = {
  asset: { url: "./room_v002_x15.jpg" },
};
